import * as Dom from '../index';
var ToolHelper = /** @class */ (function () {
    function ToolHelper() {
    }
    ToolHelper.createObjectByType = function (type) {
        var dom = Dom;
        // tslint:disable-next-line:no-eval
        return eval("dom." + type);
    };
    return ToolHelper;
}());
export { ToolHelper };
//# sourceMappingURL=toolhelper.js.map